import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { BitmapTextFieldProperties } from "@lib/titan2/dist/game/control/properties/BitmapTextFieldProperties";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractTicketSymbolProperties.ts
 */
export class AbstractTicketSymbolProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.buttonProperties.equals(other.buttonProperties) &&
            this.spineProperties.equals(other.spineProperties) &&
            this.fieldPropertiesEqual(this.symbolFieldProperties, other.symbolFieldProperties) &&
            this.fieldPropertiesEqual(this.symbolHighlightFieldProperties, other.symbolHighlightFieldProperties) &&
            this.fieldPropertiesEqual(this.symbolHighlightSuperWildFieldProperties, other.symbolHighlightSuperWildFieldProperties) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.size.equals(other.size);
    }
    fieldPropertiesEqual(a, b) {
        if (a instanceof BitmapTextFieldProperties) {
            if (b instanceof BitmapTextFieldProperties) {
                return a.equals(b);
            }
            return false;
        }
        else if (a instanceof TextFieldProperties) {
            if (b instanceof TextFieldProperties) {
                return a.equals(b);
            }
            return false;
        }
        return a === b;
    }
    setDefaultValues() {
        this.spineProperties = new SpineProperties(SlingoStyle.TICKET_SYMBOL, SlingoStyle.MODULE);
        this.buttonProperties = new ButtonProperties(SlingoStyle.TICKET_SYMBOL_BUTTON, SlingoStyle.MODULE);
        this.symbolFieldProperties = new TextFieldProperties(FontStyle.TICKET_SYMBOL, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.hideButton = false;
    }
}
//# sourceMappingURL=AbstractTicketSymbolProperties.js.map